/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DragOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';

import { Header, HeaderContainer, DragContainer, ScrollableBodyTall } from '../../../DashboardPage/GridComponents';
import messages from './messages';

const Usage = ({ isDraggable, propertyName }) => {
    const intl = useIntl();
    const [reportUrl, setReportUrl] = useState();

    const dragContainer = isDraggable && (
        <DragContainer className="draggable-item">
            <DragOutlined />
        </DragContainer>
    );

    const generateReportUrl = () => {
        const params = {
            propertyname: propertyName,
        };
        const paramsAsString = JSON.stringify(params);
        const encodedParams = encodeURIComponent(paramsAsString);
        setReportUrl(
            `https://lookerstudio.google.com/embed/reporting/5175c852-ee6d-4a09-9f5e-31e2d0144199/page/sIKeD?params=${encodedParams}`,
        );
    };

    useEffect(() => {
        generateReportUrl();
    }, [propertyName]);

    return (
        <>
            <HeaderContainer>
                <Header>{intl.formatMessage(messages.title)}</Header>
                {dragContainer}
            </HeaderContainer>
            <ScrollableBodyTall>
                <div>
                    <iframe
                        title="Usage"
                        width="900"
                        height="700"
                        allowfullscreen
                        frameBorder="0"
                        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                        src={reportUrl}
                    />
                </div>
            </ScrollableBodyTall>
        </>
    );
};

Usage.propTypes = {
    propertyName: PropTypes.string.isRequired,
};

export default Usage;
